export default __webpack_public_path__ + "static/media/Achievements3.ef359246.webp";